/*** Library of small secondary functions used for the PLP and/or search overlay ***/
import { animate } from '../../core/animations.js';
// import { previousStateLocalStorage, getURLFiltersAndSorting } from './filterState.js';

let saved_placeholders_HTML = '';
let saved_marketing_blocks_HTML = '';

// Remove the placeholders but save same before for future use
const removePlaceholders = () => {
  // console.log('[ASTR] removePlaceholders 1');
  const grid_container = document.querySelector('[data-product-tiles] .grid');
  if (!grid_container) {
    // console.log('[ASTR] removePlaceholders 2 - no grid container');
    return false;
  }

  const placeholders = grid_container.querySelectorAll('[data-product-tile].product-tile--placeholder');
  if (!placeholders.length) {
    // console.log('[ASTR] removePlaceholders 3 - no placeholders found');
    return false;
  }

  if (saved_placeholders_HTML === '') {
    saved_placeholders_HTML = Array.from(placeholders).map(el => el.outerHTML).join('');
  }
  
  // console.log('[ASTR] removePlaceholders 4 - removing placeholders');
  placeholders.forEach(tile => tile.remove());

  return true;
};

// Re-inject the placeholder while we're loading the new products
const addPlaceholders = () => {
  // console.log('[ASTR] addPlaceholders 1 - main');
  if (!saved_placeholders_HTML) {
    // console.log('[ASTR] addPlaceholders 2 - no saved placeholders HTML');
    return false;
  }

  const from_search = document.body.classList.contains('has-overlay-search');

  if (from_search) {
    // console.log('[ASTR] addPlaceholders 3 - from search overlay');
    return false;
  }

  const grid_container = (from_search) ? document.querySelector('[data-overlay-search-grid-container] .grid') : document.querySelector('[data-product-tiles] .grid');
  if (!grid_container) {
    // console.log('[ASTR] addPlaceholders 4 - no grid container');
    return false;
  }

  // console.log('[ASTR] addPlaceholders 5 - ok to continue');
  grid_container.insertAdjacentHTML('afterbegin', saved_placeholders_HTML);

  return true;
};

// Remove the marketing blocks but save same before for future use
const removeMarketingBlocks = () => {
  // console.log('[ASTR] removeMarketingBlocks 1');
  const from_search = document.body.classList.contains('has-overlay-search');
  if (from_search) {
    return false;
  }

  // console.log('[ASTR] removeMarketingBlocks 2');
  const grid_container = document.querySelector('[data-product-tiles] .grid');
  if (!grid_container) {
    return false;
  }

  // console.log('[ASTR] removeMarketingBlocks 3');
  const marketing_blocks = grid_container.querySelectorAll('marketing-block');
  if (!marketing_blocks.length) {
    return false;
  }

  // console.log('[ASTR] removeMarketingBlocks 4');
  if (saved_marketing_blocks_HTML === '') {
    saved_marketing_blocks_HTML = Array.from(marketing_blocks).map(el => el.outerHTML).join('');
  }

  // console.log('[ASTR] removeMarketingBlocks 5', from_search, window.theme.collections.page, window.theme.collections.filtering, window.theme.collections.sorting, window.localStorage.getItem('wild-third-level-url'));
  if (
    from_search ||
    (typeof window.theme.collections.page !== 'undefined' && window.theme.collections.page > 1) ||
    (typeof window.theme.collections.filtering !== 'undefined' && Array.isArray(window.theme.collections.filtering) && window.theme.collections.filtering.length > 0) ||
    (typeof window.theme.collections.sorting !== 'undefined' && window.theme.collections.sorting !== 'manual') ||
    (typeof window.localStorage.getItem('wild-third-level-url') !== 'undefined' && window.localStorage.getItem('wild-third-level-url') !== null)
  ) {
    console.log('[ASTR] Removing marketing blocks due to conditions not met');
    marketing_blocks.forEach(block => block.remove());
  }

  return true;
};

// Re-inject the marketing blocks while we're loading the new products when needed (page 1, no sort, no filters, no color in url, not from search overlay...)
// If the marketing blocks were already injected, and the conditions are met, we remove them
const addMarketingBlocks = () => {
  // console.log('[ASTR] addMarketingBlocks 1 - main');
  if (!saved_marketing_blocks_HTML) {
    return false;
  }

  // console.log('[ASTR] addMarketingBlocks 2 - has html');
  const from_search = document.body.classList.contains('has-overlay-search');

  // console.log('[ASTR] addMarketingBlocks 3', from_search, window.theme.collections.page, window.theme.collections.filtering, window.theme.collections.sorting, window.localStorage.getItem('wild-third-level-url'));
  if (
    from_search ||
    window.theme.collections.page > 1 ||
    (Array.isArray(window.theme.collections.filtering) && window.theme.collections.filtering.length > 0) ||
    (typeof window.theme.collections.sorting !== 'undefined' && window.theme.collections.sorting !== 'manual') ||
    window.localStorage.getItem('wild-third-level-url') !== null
  ) {
    // console.log('[ASTR] addMarketingBlocks 4 - call removeMarketingBlocks()');
    removeMarketingBlocks();
    return false;
  }

  // console.log('[ASTR] addMarketingBlocks 5 - ok to continue');
  const grid_container = (from_search) ? document.querySelector('[data-overlay-search-grid-container] .grid') : document.querySelector('[data-product-tiles] .grid');
  if (!grid_container) {
    // console.log('[ASTR] addMarketingBlocks 6 - no container');
    return false;
  }

  if (grid_container.querySelectorAll('marketing-block').length > 0) {
    // console.log('[ASTR] addMarketingBlocks 6 - marketing blocks already present');
    return false;
  }

  // console.log('[ASTR] addMarketingBlocks 7 - inserting marketing blocks');
  grid_container.insertAdjacentHTML('afterbegin', saved_marketing_blocks_HTML);

  // Trigger a resize event to recalculate the marketing blocks height
  window.setTimeout(() => {
    animate();
  }, 1);

  return true;
};

const removeProductTiles = () => {
  const from_search = document.body.classList.contains('has-overlay-search');

  if (from_search) {
    return false;
  }

  const grid_container = (from_search) ? document.querySelector('[data-overlay-search-grid-container] .grid') : document.querySelector('[data-product-tiles] .grid');
  if (grid_container) {
    // const product_tiles = grid_container.querySelectorAll('[data-product-tile]');
    const product_tiles = grid_container.querySelectorAll('[data-product-tile]:not(.product-tile--placeholder)');

    if (product_tiles.length) {
      product_tiles.forEach(tile => tile.remove());
    }
  }
};

// Pagination is being hidden from noResults.js
const showPagination = () => {
  const from_search = document.body.classList.contains('has-overlay-search');
  const grid_container = (from_search) ? document.querySelector('[data-overlay-search-results]') : document.querySelector('[data-product-tiles]');

  if (!grid_container) {
    return;
  }

  const pagination_count = grid_container.querySelector('.products__pagination-count');
  if (pagination_count) {
    pagination_count.classList.remove('hidden');
  }

  const pagination = grid_container.querySelector('[data-pagination]');
  if (pagination) {
    pagination.classList.remove('hidden');
  }
};

const initNumberedPagination = (nosto_nbHits_search, nosto_nbHits) => {
  const from_search = document.body.classList.contains('has-overlay-search');

  const tiles_container = (from_search) ? document.querySelector('[data-overlay-search-results]') : document.querySelector('[data-product-tiles]');

  if (!tiles_container) {
    return;
  }

  const prefix = (from_search) ? 'overlay-search-' : '';
  const f_page = (from_search) ? window.theme.search.page : window.theme.collections.page;
  const f_nosto_nbHits = (from_search) ? nosto_nbHits_search : nosto_nbHits;
  const f_per_page = (from_search) ? Number(window.theme.search.products_per_page) : Number(window.theme.collections.products_per_page);

  const pagination = document.querySelector(`[data-${prefix}pagination]`);
  if (pagination) {
    pagination.classList.remove('disabled');
  }

  const pagination_first = document.querySelector(`[data-${prefix}pagination-first]`);
  const pagination_previous = document.querySelector(`[data-${prefix}pagination-previous]`);
  const pagination_last = document.querySelector(`[data-${prefix}pagination-last]`);
  const pagination_next = document.querySelector(`[data-${prefix}pagination-next]`);

  if (pagination_first) pagination_first.classList.remove('disabled');
  if (pagination_previous) pagination_previous.classList.remove('disabled');
  if (pagination_last) pagination_last.classList.remove('disabled');
  if (pagination_next) pagination_next.classList.remove('disabled');

  if (f_page <= 1) {
    if (pagination_first) pagination_first.classList.add('disabled');
    if (pagination_previous) pagination_previous.classList.add('disabled');
  }

  const total_pages = Math.ceil(f_nosto_nbHits / f_per_page);
  if (f_page >= total_pages) {
    if (pagination_last) pagination_last.classList.add('disabled');
    if (pagination_next) pagination_next.classList.add('disabled');
  }

  const current_page_element = document.querySelector(`[data-${prefix}current-page]`);
  const total_pages_element = document.querySelector(`[data-${prefix}total-pages]`);

  if (current_page_element) current_page_element.innerHTML = f_page;
  if (total_pages_element) total_pages_element.innerHTML = total_pages;

  // Build numbered page buttons
  const pagination_page = document.querySelector(`[data-${prefix}pagination-page]`);
  if (pagination_page && total_pages > 1) {
    // Determine which page numbers to show
    const pages_to_show = new Set();
    pages_to_show.add(1);
    pages_to_show.add(total_pages);
    for (let i = Math.max(1, f_page - 1); i <= Math.min(total_pages, f_page + 1); i++) {
      pages_to_show.add(i);
    }

    const sorted_pages = Array.from(pages_to_show).sort((a, b) => a - b);

    let html = '';
    let prev = 0;
    for (const page of sorted_pages) {
      if (prev && page - prev > 1) {
        html += `<span class="pagination__page-ellipsis" aria-hidden="true">...</span>`;
      }
      if (page === f_page) {
        html += `<span class="pagination__page-number pagination__page-number--current" aria-label="Page ${page}, current" aria-current="page">${page}</span>`;
      } else {
        html += `<button type="button" class="pagination__page-number no-themed" aria-label="Go to page ${page}" data-${prefix}page="${page}">${page}</button>`;
      }
      prev = page;
    }

    pagination_page.innerHTML = html;

    // Attach click handlers
    pagination_page.querySelectorAll(`[data-${prefix}page]`).forEach(btn => {
      btn.addEventListener('click', () => {
        btn.closest(`[data-${prefix}pagination]`)?.querySelector(`[data-${prefix}pagination-first]`)?.click();
        // Dispatch a custom event that filtering.js or full-search.js handlePaginationClick can respond to
        const event = new CustomEvent(`pagination:page-${prefix}click`, { detail: { page: Number(btn.getAttribute(`data-${prefix}page`)) }, bubbles: true });
        btn.dispatchEvent(event);
      });
    });
  } else if (pagination_page && total_pages <= 1) {
    pagination_page.innerHTML = '';
  }

  const tiles_in_grid = tiles_container ? tiles_container.querySelectorAll(`[data-product-tile]`) : [];

  console.log('[ASTR] initNumberedPagination', f_page, total_pages, f_nosto_nbHits, f_per_page, tiles_in_grid.length);

  const showing_total_start = ((f_page - 1) * f_per_page) + 1;
  const showing_total_end = ((f_page - 1) * f_per_page) + tiles_in_grid.length;

  const page_total_filtered_items = tiles_container.querySelector(`[data-${prefix}page-total-filtered-items]`);
  if (page_total_filtered_items) {
    page_total_filtered_items.innerHTML = `showing ${showing_total_start} — ${showing_total_end}`;
  }

  const total_filtered_items = tiles_container.querySelector(`[data-${prefix}total-filtered-items]`);
  if (total_filtered_items) {
    total_filtered_items.innerHTML = `&nbsp;of ${f_nosto_nbHits}`;
  }

  // log('current_page', current_page, 'total_pages', total_pages);
};

const scrollToTile = (save_filter_state) => {
  console.log('[ASTR] scrollToTile');
  if (save_filter_state === false) {
    // Scroll to the last viewed product
    const previous_page = window.localStorage.getItem('previous-page') || '';

    if (previous_page.indexOf('/products/') !== -1) {
      const previous_page_parts = previous_page.split('/');
      const previous_product_parts = previous_page_parts[previous_page_parts.length - 1].split('?');
      const previous_product_handle = previous_product_parts[0];

      if (!previous_product_handle) {
        console.warn('previous_product_handle is undefined or empty.');
        return;
      }

      const productTile = document.querySelector(`[data-product-tile][data-product-handle="${previous_product_handle}"]`);
      if (productTile) {
        window.setTimeout(() => {
          const header = document.querySelector('.shopify-section.header');
          const headerHeight = header ? header.offsetHeight : 0;
          const countdownBanner = document.querySelector('[data-countdown-banner]');
          const countdownBannerHeight = countdownBanner ? countdownBanner.offsetHeight : 0;
          const filterBar = document.querySelector('[data-filters-panel-v2]');
          const filterBarHeight = filterBar ? filterBar.offsetHeight : 0;
          const subCats = document.querySelector('[data-collection-subcategories]');
          const subCatsHeight = subCats ? subCats.offsetHeight : 0;
          const recommendedSection = document.querySelector('[data-collection-grid-container] [data-recommended-products]');
          const recommendedSectionHeight = recommendedSection ? recommendedSection.offsetHeight : 0;
          const tileTop = productTile.getBoundingClientRect().top + window.pageYOffset;
          // console.log('[ASTR] scrollToTile', (tileTop - headerHeight - filterBarHeight - subCatsHeight - recommendedSectionHeight), tileTop, headerHeight, filterBarHeight, subCatsHeight, recommendedSectionHeight);

          window.scrollTo({
            top: tileTop - headerHeight - filterBarHeight - subCatsHeight - recommendedSectionHeight - countdownBannerHeight - 50,
            behavior: 'smooth'
          });
        }, 500);
      }
    }
  } else {
    // $('html, body').animate({ scrollTop: $('[data-products]').offset().top - $('.shopify-section.header').outerHeight() + 20 }, 'slow');
  }
};

// Refresh the items count and other misc options
const refreshOptions = (qty = filtered_products.length) => {
  const from_search = document.body.classList.contains('has-overlay-search');

  let plural = 's';
  if (qty === 1) {
    plural = '';
  }

  let items_html = `${qty} item${plural}`;

  if ($('body').hasClass('template-search')) {
    const page_url = new URL(window.location.href);
    const search_params = new URLSearchParams(page_url.search);

    if (search_params.has('q')) {
      items_html = `${qty} result${plural} for "${search_params.get('q')}"`;
    }
  }

  const tiles_container = (from_search) ? document.querySelector('[data-overlay-search-grid-container]') : document.querySelector('[data-product-tiles]');
  if (tiles_container) {
    if (from_search) { // we don't need this on the PLP for now
      tiles_container.querySelector('[data-total-filtered-items]').innerHTML = items_html;
    }
  }
};

/**
 * Convert the selected filters from the previous state or URL to the Nosto format
 * 
 * @param {Object} selected_filters, sorting, pagination from URL query params or local storage
 * 
 * @returns {Array} The selected filters in Nosto format
 */
/*
const convertelectedFiltersToNostoFormat = (selected_filters) => {
  // Convert data from
  // {
  //     "page": 1,
  //     "sort_by": "manual",
  //     "skus.customFields.astr-color_family": [
  //         "black",
  //         "blue"
  //     ],
  //     "skus.customFields.size": [
  //         "M"
  //     ]
  // }

  // To:
  // [
  //     [
  //         "skus.customFields.astr-color_family",
  //         "black"
  //     ],
  //     [
  //         "skus.customFields.astr-color_family",
  //         "blue"
  //     ],
  //     [
  //         "skus.customFields.size",
  //         "M"
  //     ]
  // ]

  const selected_filtering = [];

  for (const key in selected_filters) {
    if (key === 'page' || key === 'sort_by') continue;
    const value = selected_filters[key];
    if (Array.isArray(value)) {
      value.forEach(v => selected_filtering.push([key, v]));
    } else {
      selected_filtering.push([key, value]);
    }
  }

  console.log('[ASTR] 2 - selected_filtering Nosto format', selected_filtering);
  return selected_filtering;
};
*/

/**
 * Get the selected filters from the current page or previous state (local storage or URL).
 * 
 * @param {boolean} with_previous_state - If true, will return the previous state if available
 * 
 * @returns {Array} The selected filters
 */
const getSelectedFilters = (/*with_previous_state = false*/) => {
  const from_search = document.body.classList.contains('has-overlay-search');
  const prefix = (from_search) ? 'overlay-search-' : '';
  let selected_filtering = [];
  
  /*
  // For the PLP only, we check if we have a previous state saved (coming back from PDP) or URL filters
  if (!from_search) {
    // Retrieve the filter state when coming back from PDP using the data saved in localStorage
    const previous_state = (with_previous_state) ? previousStateLocalStorage() : null;
    if (previous_state !== null) {
      return convertelectedFiltersToNostoFormat(previous_state.saved_filters);
    }

    // Retrieve the filter state from the Query Params in the URL if any
    if (with_previous_state) {
      const url_filters_and_sorting = getURLFiltersAndSorting();
      if (url_filters_and_sorting !== null) {
        selected_filtering = convertelectedFiltersToNostoFormat(url_filters_and_sorting);
        if (selected_filtering.length > 0) {
          return selected_filtering;
        }
      }
    }
  }
  */

  // Get the selected filters from the current page for either PLP or search overlay
  document.querySelectorAll(`[data-${prefix}filter-options]`).forEach(option => {
    const active_options = option.querySelectorAll('[data-clickable-option].active');
    
    if (active_options.length) {
      const group_type = (from_search) ? option.dataset.overlaySearchFilterOptionsType : option.dataset.filterOptionsType;
      
      active_options.forEach(active_option => {
        selected_filtering.push([
          group_type, 
          active_option.dataset.optionValue
        ]);
      });
    }
  });
  
  // Remove duplicates due to desktop/mobile filters
  // selected_filtering = _.uniqWith(selected_filtering, _.isEqual);
  selected_filtering = Array.from(
    new Set(selected_filtering.map(JSON.stringify))
  ).map(JSON.parse);

  // selected_filtering_names = _.uniqWith(selected_filtering_names, _.isEqual);

  // Third level URL tag - /collections/whats-new/blue
  // if (!from_search) {
  //   const custom_filter_color = window.localStorage.getItem('wild-third-level-url');
  //   if (custom_filter_color !== '' && custom_filter_color !== null) {
  //     // selected_filtering.push(['options.color', custom_filter_color]);
  //     const all_color_filters = custom_filter_color.split(',');
  //     for (let i = 0; i < all_color_filters.length; i++) {
  //       selected_filtering.push(['skus.customFields.astr-color_family', all_color_filters[i]]);
  //     }
  //   }
  // }

  console.log('[ASTR] 3 - selected_filtering', from_search, selected_filtering);

  return selected_filtering;
};

/*
const updateLoadMoreButton = () => {
  const from_search = document.body.classList.contains('has-overlay-search');
  const prefix = (from_search) ? 'overlay-search-' : '';

  const load_more_button = document.querySelector(`[data-${prefix}load-more]`);
  if (load_more_button) {
    load_more_button.innerHTML = 'Load more';
    load_more_button.classList.remove('hide', 'loading');

    // const total_results = from_search ? window.theme.search.total_results : window.theme.collections.total_results;
    // const c_page = from_search ? current_page_search : current_page;

    // if (total_results <= per_page * c_page) {
    if (filtered_products_paginated.length < per_page) {
      load_more_button.classList.add('hide');
    }
  }
};

// We load another pagge when on desktop for a total of 2 x window.theme.collections.products_per_page products
// To optimize the initial load time / rendering
// one_more when the use manually clicks the load more button
const triggerNextPage = (one_more = true) => {
  if (window.theme.breakpoints.current !== 'mobile') {
    const from_search = document.body.classList.contains('has-overlay-search');
    const prefix = (from_search) ? 'overlay-search-' : '';

    if (!document.querySelector(`[data-${prefix}load-more]`).classList.contains('hide')) {
      document.querySelector(`[data-${prefix}load-more]`).click();
    }

    window.trigger_on_more_page = one_more;
  }
};
*/

export {
  removePlaceholders,
  removeMarketingBlocks,
  addPlaceholders,
  addMarketingBlocks,
  removeProductTiles,
  showPagination,
  initNumberedPagination,
  scrollToTile,
  refreshOptions,
  getSelectedFilters,
};
